export default [
    {
      path: '/reports',
      name: 'Reports',
      component: () => import('@/components/adm/reports/IndexReport.vue'),
      meta: {
        title: "Relatórios"
      }
    },
    {
      path: '/relatorio-servico',
      name: 'Service-report',
      component: () => import('@/components/adm/reports/service-report/ServiceReport.vue'),
      meta: {
        title: "Relatórios > Serviços de Pesagens"
      }
    },
    {
      path: '/relatorio-servico-validado',
      name: 'Validated-service-report',
      component: () => import('@/components/adm/reports/service-validated-report/ServiceValidatedReport.vue'),
      meta: {
        title: "Relatórios > Serviços Validados"
      }
    },
    {
      path: '/relatorio-ril',
      name: 'Ril-report',
      component: () => import('@/components/adm/reports/ril-report/RilReport.vue'),
      meta: {
        title: "Relatórios > R.I.L"
      }
    },
    {
      path: '/relatorio-analise-leite',
      name: 'Milk-report',
      component: () => import('@/components/adm/reports/milk-report/MilkReport.vue'),
      meta: {
        title: "Relatórios > Análises do Leite"
      }
    },
    {
      path: '/relatorio-interpolacao',
      name: 'Interpolation-report',
      component: () => import('@/components/adm/reports/interpolation-report/InterpolationReport.vue'),
      meta: {
        title: "Relatórios > Interpolação das Ordenhas"
      }
    },
    {
      path: '/relatorio-rmpi',
      name: 'Rmpi-report',
      component: () => import('@/components/adm/reports/rmpi-report/RmpiReport.vue'),
      meta: {
        title: "Relatórios > R.M.P.I"
      }
    },
    {
      path: '/lact-del',
      name: 'Lactation-curve',
      component: () => import('@/components/adm/reports/lactation-curve/LactationCurve.vue'),
      meta: {
        title: "Relatórios > Curva de Lactação x DEL"
      }
    },
    {
      path: '/relatorio-record-producao-vit',
      name: 'Production-record',
      component: () => import('@/components/adm/reports/production-record/ProductionRecord.vue'),
      meta: {
        title: "Relatórios > Recorde Produção Vitalícia"
      }
    },
    {
      path: '/relatorio-record-producao',
      name: 'Production-record-single',
      component: () => import('@/components/adm/reports/production-record-single/ProductionRecordSingle.vue'),
      meta: {
        title: "Relatórios > Recorde de Produção"
      }
    },
    {
      path: '/relatorio-r2',
      name: 'Report-r2',
      component: () => import('@/components/adm/reports/report-r2/ReportR2.vue'),
      meta: {
        title: "Relatórios > R2"
      }
    },
    {
      path: '/relatorio-extracao-leite',
      name: 'Milk-extraction-report',
      component: () => import('@/components/adm/reports/milk-extraction-report/MilkExtractionReport.vue'),
      meta: {
        title: "Relatórios > Extrato de Lactação"
      }
    },
  ]